import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";

const COLORS = { confirmed: "text-emerald-400", mismatch: "text-red-400", partial: "text-amber-400", not_found: "text-stone-500", unverified: "text-stone-500" };

export const FactStatus = ({ it, testId }) => {
  const s = it.fact_status;
  if (!s) return <span className="text-[10px] font-mono-ui text-stone-600">facts: not run</span>;
  return <span data-testid={testId} className={`text-[10px] font-mono-ui uppercase tracking-wider ${COLORS[s]}`}>facts: {s}</span>;
};

export const FactDetails = ({ kit, it, reload }) => {
  const facts = it.facts || {};
  const fields = Object.keys(facts);
  if (!fields.length) return it.fact_note ? <div className="text-xs text-stone-500 mt-1.5">{it.fact_note}</div> : null;
  const apply = async (field) => {
    try {
      await http.post(`/kits/${kit.id}/verification/${it.id}/apply`, { field });
      toast.success(`Updated ${field} from official source`);
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-2 space-y-1.5" data-testid={`fact-details-${it.id}`}>
      {fields.map((f) => {
        const x = facts[f];
        return (
          <div key={f} className="text-xs">
            <span className="font-mono-ui uppercase text-stone-500 mr-1.5">{f}</span>
            <span className={COLORS[x.status]}>{x.status?.replace("_", " ")}</span>
            <span className="text-stone-500"> · kit: {x.claimed}</span>
            {x.status === "mismatch" && x.source_value && (
              <div className="mt-0.5 flex items-center gap-2 flex-wrap">
                <span className="text-stone-600">source: {x.source_value}</span>
                <button data-testid={`fact-apply-${it.id}-${f}`} onClick={() => apply(f)} className="rounded-sm border border-[#C9A847]/40 px-2 py-0.5 text-[10px] text-[#9A7B2C] hover:bg-[#C9A847]/10">Use source value</button>
              </div>
            )}
            {x.source_url && <a href={x.source_url} target="_blank" rel="noreferrer" className="block text-[10px] text-stone-600 hover:text-stone-600 truncate max-w-[260px]">{x.source_url}</a>}
          </div>
        );
      })}
      {it.fact_note && <div className="text-[11px] text-stone-500 italic">{it.fact_note}</div>}
    </div>
  );
};
